import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
import { ZapIcon } from 'lucide-react';
export const StickyBar: React.FC = () => {
  const {
    formattedTime
  } = useCountdown();
  return <div className="fixed top-0 left-0 w-full z-50 shadow-md" style={{
    background: 'linear-gradient(90deg, var(--gold-dark), var(--gold), var(--gold-dark))'
  }} data-id="element-166">
      <div className="container mx-auto px-4 py-3 flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-3 text-sm sm:text-base font-semibold" style={{
      color: 'var(--bg-dark)'
    }} data-id="element-167">
        <div className="flex items-center gap-2" data-id="element-168">
          <ZapIcon className="w-4 h-4 fill-current" data-id="element-169" />
          <span className="tracking-wide" data-id="element-170">Oferta especial termina en:</span>
        </div>
        <div className="flex items-center gap-1 font-serif text-xl font-extrabold tracking-wider" data-id="element-171">
          <span data-id="element-172">{formattedTime.minutes}</span>
          <span data-id="element-173">:</span>
          <span data-id="element-174">{formattedTime.seconds}</span>
        </div>
        <span className="hidden md:inline text-sm" data-id="element-175">
          · Precio de lanzamiento 2026
        </span>
      </div>
    </div>;
};